<sgt-multi-select
  [settings]="settingsDoSelect"
  [options]="options"
  [variante]="variante"
  [icon]="icon"
  [(ngModel)]="situacoes"
  (ngModelChange)="onSelectionChange()"
  (search)="onSearch()">
</sgt-multi-select>
